import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76d8329f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = { class: "flex-wrapper" }
const _hoisted_3 = { class: "modal" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "header-wrapper" }
const _hoisted_6 = { class: "dropdown-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "workspace" }, "Asana workspace", -1))
const _hoisted_8 = {
  key: 0,
  disabled: "",
  value: "null"
}
const _hoisted_9 = ["value", "name"]
const _hoisted_10 = { class: "dropdown-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "project" }, "Asana project", -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  disabled: "",
  value: "null"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value", "name"]
const _hoisted_16 = { class: "footer" }
const _hoisted_17 = {
  key: 0,
  class: "spinner light"
}
const _hoisted_18 = { key: 1 }

import { postData, putData } from "@/api"
import { ref } from "vue"
import { useUserStore } from "@/store"
import { notify } from "@/globals/notification"


export default /*#__PURE__*/_defineComponent({
  props: {
  webhook: Object,
  webhook_index: Number
},
  emits: ["closeModal"],
  setup(__props, { emit }) {

const props = __props

const store = useUserStore()


const loading = ref(false)
const updating = ref(false)

/*eslint-disable no-undef*/


const currentWorkspace = store.webhooks[props.webhook_index].asana_workspace_id
const currentProject = store.webhooks[props.webhook_index].asana_project_id

const selectedWorkspace = ref(
  store.webhooks[props.webhook_index].asana_workspace_id
)
const selectedWorkspaceName = ref(
  store.webhooks[props.webhook_index].asana_workspace_name
)

const selectedProject = ref(
  store.webhooks[props.webhook_index].asana_project_id
)

const selectedProjectName = ref(
  store.webhooks[props.webhook_index].asana_project_name
)

const updateWorkspace = () => {
  selectedProject.value = null
  getProjects(selectedWorkspace.value)
  if (selectedWorkspace.value === currentWorkspace) {
    selectedProject.value = currentProject
  }
}

const closeModal = () => {
  emit("closeModal", false)
}

document.addEventListener("keydown", (e) => {
  if (e.key == "Escape") {
    closeModal()
  }
})

const getProjects = async (gid: string) => {
  loading.value = true
  const data = await postData(`${store.BASE_URL}/asana/workspaces/projects`, {
    workspace: gid
  })
  store.asana_projects = data.projects
  console.log(data)
  loading.value = false
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _updateWorkspaceName = async (e: any) => {
  if (e.target.options.selectedIndex > -1) {
    selectedWorkspaceName.value =
      e.target.options[e.target.options.selectedIndex].text
  }
  console.log(selectedWorkspaceName.value)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _updateProjectName = async (e: any) => {
  if (e.target.options.selectedIndex > -1) {
    selectedProjectName.value =
      e.target.options[e.target.options.selectedIndex].text
  }
  console.log(selectedProjectName.value)
}

const updateProject = async () => {
  updating.value = true
  const data = await putData(`${store.BASE_URL}/figma/webhooks`, {
    id: store.webhooks[props.webhook_index].id,
    webhook_id: store.webhooks[props.webhook_index].webhook_id,
    asana_workspace_name: selectedWorkspaceName.value,
    asana_workspace_id: selectedWorkspace.value,
    asana_project_id: selectedProject.value,
    asana_project_name: selectedProjectName.value
  })

  // eslint-disable-next-line no-prototype-builtins
  if ("error" in data) {
    notify(data.error, true)
    updating.value = false
    return
  }

  store.webhooks[props.webhook_index] = data.webhook

  notify("Settings updated", false)
  updating.value = false

  console.log(`Workspace name: ${selectedWorkspaceName.value}`)
  console.log(`Workspace id: ${selectedWorkspace.value}`)
  console.log(`Project name: ${selectedProjectName.value}`)
  console.log(`Project id: ${selectedProject.value}`)
}

if (store.webhooks[props.webhook_index].asana_workspace_id) {
  getProjects(store.webhooks[props.webhook_index].asana_workspace_id)
}

if (store.webhooks[props.webhook_index].asana_project_id) {
  selectedProject.value = store.webhooks[props.webhook_index].asana_project_id
}

// const hasProject = computed(() => "Sup")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", null, _toDisplayString(_unref(store).webhooks[props.webhook_index].team.team_name) + " settings ", 1),
            _createElementVNode("div", {
              onClick: closeModal,
              class: "close"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("select", {
              onChange: _cache[0] || (_cache[0] = ($event: any) => (updateWorkspace(), _updateWorkspaceName($event))),
              id: "workspace",
              name: "workspace",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedWorkspace).value = $event))
            }, [
              (!selectedWorkspace.value)
                ? (_openBlock(), _createElementBlock("option", _hoisted_8, " Select a workspace "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).asana_workspaces, (workspace) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: workspace.gid,
                  value: workspace.gid,
                  name: workspace.name
                }, _toDisplayString(workspace.name), 9, _hoisted_9))
              }), 128))
            ], 544), [
              [_vModelSelect, selectedWorkspace.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("select", {
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_updateProjectName($event))),
              id: "project",
              disabled: loading.value,
              name: "project",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedProject).value = $event))
            }, [
              (!selectedProject.value)
                ? (_openBlock(), _createElementBlock("option", _hoisted_13, _toDisplayString(loading.value ? "Loading..." : "Select a project"), 1))
                : _createCommentVNode("", true),
              (selectedProject.value != null && loading.value)
                ? (_openBlock(), _createElementBlock("option", {
                    key: 1,
                    value: props.webhook.asana_project_id
                  }, _toDisplayString(props.webhook.asana_project_name), 9, _hoisted_14))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).asana_projects, (project) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: project.gid,
                  value: project.gid,
                  name: project.name
                }, _toDisplayString(project.name), 9, _hoisted_15))
              }), 128))
            ], 40, _hoisted_12), [
              [_vModelSelect, selectedProject.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: updateProject,
            class: "update primary"
          }, [
            (updating.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17))
              : _createCommentVNode("", true),
            (!updating.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Save settings"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})